import React from "react";
import "./Spinner.scss";

const Spinner : React.FC = () => {
  return (
    <div className="app-spinner-wrapper">
      <div className="app-spinner">
        <div className="app-loader-graphic loader" />
        <p className="app-loader-graph__text">Loading...</p>
      </div>
    </div>
  );
};

export default Spinner;